<template>
    <div id="app">
        <router-view/>
        <modal :msg="modalMessage" :status="modalStatus" @close="closeModal"></modal>
        <loading :status="loadingStatus"></loading>
    </div>
</template>

<script>
    import Modal from "../../components/modal";
    import Loading from "../../components/Loading";
    import {mapState} from "vuex";

    export default {
        name: 'App',
        components: {
            Modal,
            Loading,
        },
        data() {
            return {}
        },
        created() {
            localStorage.removeItem('vuex.app');
        },
        mounted() {
            const vm = this

        },
        methods: {
            closeModal() {
                console.log('closeModal');
                this.$store.commit('setModalStatus', false)

            }
        },
        computed: {
            ...mapState([
                'modalMessage',
                'modalStatus',
                'loadingStatus'
            ]),

        }
    }
</script>

<style lang="scss">
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: $text-color;
        height: 100%;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
